import React from 'react';
import Box from '@mui/material/Box';

interface LoadingPanelProps {
  coverMode?: boolean;
}
const LoadingPanel: React.FC<LoadingPanelProps> = ({ coverMode = false }) => {
  if (coverMode) {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(18,18,18,0.5)',
          zIndex: 10,
        }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <div id="jumpingDotLoaderSmall">
          <span />
          <span />
          <span />
        </div>
      </Box>
    );
  }
  return (
    <Box minHeight={200} display="flex" alignItems="center" justifyContent="center">
      <div id="jumpingDotLoaderSmall">
        <span />
        <span />
        <span />
      </div>
    </Box>
  );
};
export default LoadingPanel;
